import React from "react";
import { features } from "../../data/mockData";
import { TreePine, Utensils, PartyPopper, Heart } from "lucide-react";
import useInView from "../../hooks/useInView";

const iconMap = {
  Golf: TreePine,
  Utensils: Utensils,
  PartyPopper: PartyPopper,
  Heart: Heart,
};

const FeaturesGrid = () => {
  const [featuresRef, featuresInView] = useInView();

  return (
    <section ref={featuresRef} className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="text-[#C9A96E] text-sm font-medium tracking-[0.2em] uppercase">
            Why Choose Us
          </span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1B2A4A] mt-3">
            The Complete Experience
          </h2>
          <p className="text-gray-500 mt-4 max-w-2xl mx-auto">
            From championship golf to elegant events, Willow Ridge offers
            everything you need for an exceptional experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.title}
                className={`group p-8 rounded-xl bg-gray-50 hover:bg-[#1B2A4A] transition-all duration-500 hover:shadow-xl hover:-translate-y-1 ${
                  featuresInView
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-8"
                }`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="w-14 h-14 rounded-lg bg-[#C9A96E]/10 group-hover:bg-[#C9A96E]/20 flex items-center justify-center mb-6 transition-colors duration-500">
                  <IconComponent
                    size={28}
                    className="text-[#C9A96E] transition-colors duration-500"
                  />
                </div>
                <h3 className="text-lg font-serif font-bold text-[#1B2A4A] group-hover:text-white mb-3 transition-colors duration-500">
                  {feature.title}
                </h3>
                <p className="text-gray-500 group-hover:text-white/70 text-sm leading-relaxed transition-colors duration-500">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export { FeaturesGrid };
